import React, { ReactElement, useState } from "react";
import { FiTrash2 } from "react-icons/fi";
import Confirm from "../confirm/Confirm";

export interface ActionButton {
    text: string;
    icon: ReactElement;
    onClick: () => void;
}

export default function PageActions({
    onDelete,
    deleteConfirm,
    type,
    className,
    buttons,
}: {
    onDelete: () => void;
    deleteConfirm?: ReactElement;
    type?: "border" | "subtle";
    className?: string;
    buttons?: ActionButton[];
}): ReactElement {
    const [shouldDisplayDelete, setShouldDisplayDelete] = useState(false);
    return (
        <div className={` bg-white align-items-center d-flex justify-content-between ${
            type === "border" ? "rounded border p-3 " : "border-top p-1"
        } ${className}`}
        >
            {deleteConfirm && (
                <Confirm
                    confirmText="Delete"
                    onConfirm={onDelete}
                    shouldShow={shouldDisplayDelete}
                    onHide={() => setShouldDisplayDelete(false)}
                >
                    {deleteConfirm}
                </Confirm>
            )}
            <strong className={`d-block ${type === "subtle" ? "text-light" : ""}`}>Actions</strong>
            <div className="d-flex gap-2">

                {buttons?.map(({ text, icon, onClick }) => (
                    <button
                        key={text}
                        type="button"
                        className="d-block btn btn-none text-gray-500  py-0 pe-0"
                        onClick={() => (onClick())}
                    >
                        {icon}
                        {" "}
                        {text}
                    </button>
                ))}
                {onDelete && (
                    <button
                        type="button"
                        className="d-block btn btn-none text-gray-500  py-0 pe-0"
                        onClick={() => (deleteConfirm ? setShouldDisplayDelete(true) : onDelete())}
                    >
                        <FiTrash2 />
                        {" "}
                        Delete
                    </button>
                )}

            </div>

        </div>
    );
}

PageActions.defaultProps = {
    deleteConfirm: undefined,
    type: "border",
    className: "",
    buttons: [],
};
